import { useCallback, useContext } from 'react'

import { AsyncCreatableSelect, AsyncSelect } from 'tools/Select'
import { LIST_TAGS } from 'tools/SelectTags/graphql'
import { selectStyle } from 'utils/selectStyles'

import GlobalContext from 'reducer/global'

function defNormalizeOption(tag) {
  return { ...tag, value: tag.label }
}

function TagSelector({
  normalizeOption,
  tagType,
  value,
  setValue,
  create,
  multi = undefined,
  className = '',
  placeholder = undefined,
  defaultOptions = undefined,
  components = undefined
}) {
  const [{ apollo, user }] = useContext(GlobalContext)
  if (!normalizeOption) normalizeOption = defNormalizeOption

  if (value) {
    value = value.map(normalizeOption)
    if (!multi) {
      value = value[0]
    }
  }

  const loadOptions = useCallback(
    (matching, setOptions) => {
      apollo
        .query({
          query: LIST_TAGS,
          variables: { type: tagType, matching }
        })
        .then(({ data }) => {
          if (data && data.tags) {
            setOptions(data.tags.map(normalizeOption))
          }
        })
        .catch((x) => console.log('Load ERROR', x))
    },
    [apollo, normalizeOption, tagType]
  )

  const styles = selectStyle(user)
  const args = {
    components,
    className,
    defaultOptions,
    cacheOptions: true,
    placeholder,
    loadOptions,
    isMulti: multi,
    styles,
    value,
    onChange: setValue
  }

  if (!create) return <AsyncSelect {...args} />

  return (
    <AsyncCreatableSelect
      {...args}
      noOptionsMessage={() => <>Start typing to find options</>}
    />
  )
}

export default TagSelector
